module.exports = __webpack_public_path__ + "static/media/drone.caf3e682.svg";